/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CTAs
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	ctas: {
		textAlign: 'center',
		'& .button': {
			marginBottom: pxToEm(10)
		},
		'&.type-block': { 
			'& .button': { 
				display: 'block', 
				width: '100%',
				'&:last-child': {
					marginBottom: '0'
				}
			}
		},
		'&.type-inline': { 
			'& .button': { 
				display: 'inline-block', 
				width: '49%', 
				marginRight: '2%',
				'&:last-child': {
					marginRight: '0'
				}
			}
		}
	}
};